import React from "react";
// Ensure this path points to your logo
import Logo from "./Images/logo1.png"; 

const Footer = () => {
  return (
    <footer 
      itemScope 
      itemType="https://schema.org/EducationalOrganization"
      className="bg-[#0a0a0a] text-gray-400 pt-20 pb-10 border-t-[3px] border-[#C0392B] font-sans antialiased"
    >
      {/* SEO: Added itemScope and itemType to declare this as an Educational Organization */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Top Section: Brand & Newsletter */}
        <div className="flex flex-col lg:flex-row justify-between items-start gap-12 mb-16 border-b border-gray-800 pb-12">
          
          {/* Brand */}
          <div className="max-w-md">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src={Logo} 
                alt="AnaBel Institute - Quality Teacher Education Logo" 
                itemProp="logo"
                className="w-14 h-14 object-contain bg-white rounded-full p-1"
                loading="lazy"
              />
              <span itemProp="name" className="text-3xl font-extrabold text-white tracking-tight">AnaBel Institute</span>
            </div>
            <p itemProp="description" className="text-sm leading-relaxed mb-8">
              Empowering youth with quality teacher education since 2007. Government approved, nationally recognized, and dedicated to building the educators of tomorrow.
            </p>
            
            {/* Socials */}
            <div className="flex items-center gap-5">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                itemProp="sameAs"
                aria-label="Visit AnaBel Institute on Facebook"
                className="text-gray-500 hover:text-[#1877F2] focus:text-[#1877F2] active:scale-90 transition-all duration-200"
              >
                <span className="sr-only">Facebook</span>
                <svg className="w-6 h-6 fill-current" aria-hidden="true" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.469h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.469h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                itemProp="sameAs"
                aria-label="Visit AnaBel Institute on Instagram"
                className="text-gray-500 hover:text-[#E4405F] focus:text-[#E4405F] active:scale-90 transition-all duration-200"
              >
                <span className="sr-only">Instagram</span>
                <svg className="w-6 h-6 fill-current" aria-hidden="true" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                itemProp="sameAs"
                aria-label="Visit AnaBel Institute on X (Twitter)"
                className="text-gray-500 hover:text-white focus:text-white active:scale-90 transition-all duration-200"
              >
                <span className="sr-only">Twitter / X</span>
                <svg className="w-5 h-5 fill-current" aria-hidden="true" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
            </div>
          </div>

          {/* Newsletter Subscription */}
          <div className="w-full lg:w-[400px]">
            <h4 className="text-white text-base font-semibold mb-3">Subscribe to our Newsletter</h4>
            <p className="text-sm mb-4">Stay updated with the latest news and admission alerts.</p>
            <form className="flex flex-col sm:flex-row gap-2" onSubmit={(e) => e.preventDefault()} aria-label="Newsletter Subscription Form">
              <input 
                type="email" 
                aria-label="Email Address for Newsletter"
                placeholder="Enter your email" 
                className="w-full px-4 py-3 bg-[#1a1a1a] border border-gray-800 rounded-md focus:outline-none focus:border-[#C0392B] focus:ring-1 focus:ring-[#C0392B] transition-all text-white text-sm"
                required
              />
              <button 
                type="submit" 
                className="px-6 py-3 bg-[#C0392B] hover:bg-[#A93226] text-white text-sm font-semibold rounded-md transition-colors whitespace-nowrap"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Main Grid Section */}
        <nav aria-label="Footer Navigation" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-16">
          
          {/* Quick Links */}
          <div>
            <h4 className="text-white text-sm font-bold mb-5 uppercase tracking-widest">Navigation</h4>
            <ul className="space-y-3 text-sm">
              {['Home', 'Courses', 'Admissions', 'About Us', 'Contact'].map((link) => (
                <li key={link}>
                  <a 
                    href={`/${link.toLowerCase().replace(' ', '') === 'home' ? '' : link.toLowerCase().replace(' ', '')}`} 
                    className="hover:text-white transition-colors duration-200"
                    title={`Go to ${link} page`}
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="text-white text-sm font-bold mb-5 uppercase tracking-widest">Programs</h4>
            <ul className="space-y-3 text-sm">
              <li><a href="/courses" title="View Nursery Teachers Training course" className="hover:text-white transition-colors duration-200">Nursery Teachers Training</a></li>
              <li><a href="/courses" title="View Montessori Training course" className="hover:text-white transition-colors duration-200">Montessori Training</a></li>
              <li><a href="/courses" title="View Primary Teachers Training course" className="hover:text-white transition-colors duration-200">Primary Teachers Training</a></li>
              <li><a href="/courses" title="View Diploma in Admin course" className="hover:text-white transition-colors duration-200">Diploma in Admin</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-2">
            <h4 className="text-white text-sm font-bold mb-5 uppercase tracking-widest">Contact Information</h4>
            <div className="grid sm:grid-cols-2 gap-6 text-sm">
              <div>
                <p className="mb-1 text-gray-500 uppercase text-xs font-semibold tracking-wider">Address</p>
                <address 
                  itemProp="address" 
                  itemScope 
                  itemType="https://schema.org/PostalAddress" 
                  className="leading-relaxed not-italic"
                >
                  <span itemProp="streetAddress">1475, Park Rd, Opp Samskrutha Bhavan<br />Rangoli Halla</span>, <br />
                  <span itemProp="addressLocality">Hassan</span><br />
                  <span itemProp="addressRegion">Karnataka</span> <span itemProp="postalCode">573201</span>
                </address>
              </div>
              <div className="space-y-4">
                <div>
                   <p className="mb-1 text-gray-500 uppercase text-xs font-semibold tracking-wider">Inquiries</p>
                   <a itemProp="email" href="mailto:anabel@gmail.com" className="hover:text-white block transition-colors">anabelinstitution@gmail.com</a>
                </div>
                <div>
                   <p className="mb-1 text-gray-500 uppercase text-xs font-semibold tracking-wider">Phone</p>
                   <a itemProp="telephone" href="tel:+919964451828" className="hover:text-white block transition-colors">+91 99644 51828</a>
                   <a itemProp="telephone" href="tel:+918884618113" className="hover:text-white block transition-colors">+91 88846 18113</a>
                </div>
              </div>
            </div>
            
            {/* Corporate WhatsApp Button */}
            <div className="mt-6">
              <a 
                href="https://wa.me/918884618115?text=Hello,%20I%20would%20like%20to%20know%20more%20about%20your%20programs." 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Chat with AnaBel Institute support on WhatsApp"
                className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1EBE5D] text-white py-2 px-4 rounded font-medium transition-colors text-sm"
              >
                <svg className="w-4 h-4 fill-current" aria-hidden="true" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>
                WhatsApp Support
              </a>
            </div>
          </div>

        </nav>

        {/* Bottom Legal Bar */}
        <div className="pt-6 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4 text-xs font-medium">
          <p>
            &copy; {new Date().getFullYear()} AnaBel Institute. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="/privacy" title="Read our Privacy Policy" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="/terms" title="Read our Terms of Service" className="hover:text-white transition-colors">Terms of Service</a>
            <a href="/sitemap" title="View website Sitemap" className="hover:text-white transition-colors">Sitemap</a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;